import i18n from '@/plugins/i18n';
const apm = {
  key: 'alert',
  name: 'Alerts ',
  icon: 'alert',
  navTabs: [
    {
      name: i18n.global.t('generated-alerts'),
      path: 'generated',
      fullPath: '/alert/generated',
    },
    {
      name: i18n.global.t('sm.configuredAlerts'),
      path: 'configured',
      fullPath: '/alert/configured',
    },
    {
      name: i18n.global.t('notificationChannels'),
      path: 'channels',
      fullPath: '/alert/channels',
    },
  ],
};
export default apm;
